import React, { useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import HTMLFlipBook from 'react-pageflip'; 

const Newsletter1 = () => {
    
    const { state } = useLocation();
    const navigate = useNavigate();
    const flipBookRef = useRef();
    const newsletter = state?.newsletter;
    const goToNextPage = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipNext(); // Call flipNext method
        }
    };

    const goToPreviousPage = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipPrev(); // Call flipPrev method
        }
    };
    if (!newsletter) {
        return (
            <div className="container mt-5">
                <p>No newsletter selected. <button onClick={() => navigate(-1)}>Go Back</button></p>
            </div>
        );
    }
    return (
        <>
           
            <div className="container">
            {newsletter === "news1" && (
                <div className="row inner-content">
                <div className="col-md-12">
                    <div className="flipOpen">
                        <HTMLFlipBook ref={flipBookRef} width={600} height={800} minWidth={315} maxWidth={1000} minHeight={400} mobileScrollSupport={true} showCover={true} useMouseEvents={true} className="flipPageComponent" pageBackground="rgb(255, 255, 255)" uncutPages={true} >
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter1.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter2.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter3.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter4.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter5.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter6.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter7.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter8.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter9.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter10.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter11.jpg" alt="Page 1" /></div>
                            <div><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter12.jpg" alt="Page 1" /></div>
                        </HTMLFlipBook>
                    </div>
                    <div className="navigation-buttons">
                        <button onClick={goToPreviousPage} className="btn btn-primary">
                        <i class="bi bi-arrow-left"></i>
                        </button>
                        <button onClick={goToNextPage} className="btn btn-primary">
                        <i class="bi bi-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
            )} 
            </div>
           
        </>
    );
};

export default Newsletter1;
